import { useEffect, useState } from "react";
import api, { apiError } from "@/lib/api";
import { CHANNEL_MGR } from "@/constants/testIds";
import { Rocket } from "lucide-react";
import { toast } from "sonner";

export default function ChannelManagerCard() {
  const [enabled, setEnabled] = useState(false);
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api
      .get("/settings/channel-manager")
      .then((r) => setEnabled(!!r.data.enabled))
      .catch(() => {});
  }, []);

  const toggle = async (next) => {
    setBusy(true);
    try {
      const { data } = await api.put("/settings/channel-manager", { enabled: next });
      setEnabled(!!data.enabled);
      toast.success(
        next
          ? "Newport Stays Channel Manager enabled (beta)"
          : "Reverted to Hostaway only",
      );
    } catch (err) {
      toast.error(apiError(err));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="ns-card p-8">
      <div className="flex items-center gap-3">
        <div className="w-10 h-10 rounded-full bg-teal-50 text-teal-700 flex items-center justify-center">
          <Rocket className="w-5 h-5" />
        </div>
        <div>
          <div className="ns-label">Beta</div>
          <div className="font-serif text-2xl">Newport Stays Channel Manager</div>
        </div>
      </div>
      <div className="ns-hairline my-6" />
      <p className="text-sm text-slate-500 max-w-xl">
        Turn this on to run Newport Stays as your own channel manager: unified calendar,
        iCal for Airbnb / Booking.com / Vrbo / Expedia, rate & availability control,
        cleaning board and a direct-booking page — all under your own brand. Hostaway keeps
        running in parallel so you can flip back at any time.
      </p>
      <label className="flex items-center gap-3 text-sm text-slate-700 select-none cursor-pointer mt-4">
        <input
          data-testid={CHANNEL_MGR.toggle}
          type="checkbox"
          checked={enabled}
          disabled={busy}
          onChange={(e) => toggle(e.target.checked)}
          className="w-4 h-4 accent-teal-600"
        />
        <span>Use Newport Stays Channel Manager (beta)</span>
      </label>
    </div>
  );
}
